import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const MyPharmacyHistoryPage = lazy(() => import("./MyPharmacyHistoryPage"));

const MyPharmacyHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MyPharmacyHistoryPage />
    </Suspense>
  );
};

export default MyPharmacyHistoryPageLazy;
